import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRtcIconBorder = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800.2",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M0 0h800v800H0z"
	}), /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M200 200v180l100-80h50v300h100V300h50l100 80V200Z" }), /* @__PURE__ */ _jsx("path", { d: "M50 50v700h700V50H50Zm600 600H150V150h500v500Z" })]
	})]
});
export default SvgRtcIconBorder;
